import { CERTIFICATION } from './dataset';
import styles from './index.module.css';
import { TLink, TMainHead, TSubHead } from './types';

const MainHead = ({
  heading,
  borderBottomRequired = true,
}: TMainHead): JSX.Element => {
  return (
    <div
      className={`text-grey-400 tracking-widest font-semibold text-base uppercase ${
        borderBottomRequired && `${styles.borderBottom}`
      }`}
    >
      {heading}
    </div>
  );
};

const SubHead = ({ text }: TSubHead): JSX.Element => {
  return (
    <div className={`font-semibold text-base text-grey-400 mt-8 mb-[14px]`}>
      {text}
    </div>
  );
};

const List = ({ text, link }: TLink): JSX.Element => {
  return (
    <a
      href={link}
      className={`block font-normal text-s-14 text-grey-500 opacity-70 mb-3 cursor-pointer hover:underline hover:text-white hover:opacity-100 hover:font-medium`}
    >
      {text}
    </a>
  );
};

const ButtonList = ({ text, link }: TLink): JSX.Element => {
  return (
    <a href={link} className={`${styles.buttonList}`}>
      <div>{text}</div>
    </a>
  );
};

const SubFooter = () => {
  return (
    <div className="mt-20 flex justify-between gap-8 md:flex-col sm:flex-col sm:mt-10">
      <div>
        <p
          className={`text-base font-bold tracking-wide uppercase mb-2 text-grey-400`}
        >
          Cleartax is a product by Defmacro Software Pvt. Ltd.
        </p>
        <p className={`flex gap-8 text-s-14 text-grey-500 opacity-70`}>
          <span>Company Policy</span>
          <span>Terms of use</span>
        </p>
      </div>
      <div className="flex gap-8 sm:flex-col">
        {CERTIFICATION.map((item) => (
          <div className="flex items-center gap-3" key={item.altText}>
            <img
              src={item.image}
              alt={item.altText}
              width={item.imageWidth}
              height={item.imageHeight}
            />
            {item.texts.map((text) => (
              <p key={text} className={`text-s-14 text-grey-500 opacity-70`}>
                {text}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export { MainHead, SubHead, List, ButtonList, SubFooter };
